















































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Types
import { IDocsCategory } from "@/models/docs";

@Component({
  components: {
    "docs-categories-provider": () =>
      import("@/components/app/global/docs/docsCategoriesProvider.vue"),
    "docs-categories-list": () =>
      import("@/components/app/global/docs/docsCategoriesList.vue"),
    "category-docs-provider": () =>
      import("@/components/app/global/docs/categoryDocsProvider.vue"),
    "category-docs-list": () =>
      import("@/components/app/global/docs/categoryDocsList.vue"),
    "docs-search": () => import("@/components/app/global/docs/docsSearch.vue")
  }
})
export default class ShowDocs extends Vue {
  // Props

  @Prop({ required: true })
  public categorySlug!: IDocsCategory["slug"] | null;

  @Prop({ required: true })
  public docsSlugs!: IDocsCategory["slug"][] | null;

  @Prop({ default: "" })
  public docsSearchQuery!: string | null;

  // Variables

  public isSearching = false;
  public usedCategorySlug = this.categorySlug;
  public showCategoriesView =
    _.isNull(this.categorySlug) || this.categorySlug === "";

  // Methods

  public changeView(
    showCategoriesView: boolean,
    categorySlug: IDocsCategory["slug"] | null = null
  ) {
    this.usedCategorySlug = categorySlug;
    this.showCategoriesView = showCategoriesView;
  }
}
